import { getFirestore, doc, getDoc, setDoc, Timestamp } from "firebase/firestore";
import { mapFirebaseError } from "./errorMapper";
export class FirebaseSettingsRepository {
    db = getFirestore();
    async getDoc(id) {
        try {
            const snap = await getDoc(doc(this.db, "settings", id));
            return snap.exists() ? snap.data() : null;
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
    async fetchLegalDocument(kind) {
        const data = await this.getDoc(kind);
        return {
            content: data?.content ?? "",
            lastUpdated: data?.lastUpdated ?? "",
        };
    }
    async fetchAdBanner() {
        const data = await this.getDoc("ad_banner");
        return {
            enabled: data?.enabled ?? false,
            startDate: data?.startDate?.toDate() ?? null,
            endDate: data?.endDate?.toDate() ?? null,
            imageUrl: data?.imageUrl ?? null,
            pointToUrl: data?.pointToUrl ?? null,
        };
    }
    async fetchAppConfig() {
        const data = await this.getDoc("app_config");
        return {
            minVersion: data?.minVersion ?? "1.0",
            forceUpdate: data?.forceUpdate ?? false,
            updateMessage: data?.updateMessage ?? "",
            storeUrl: data?.storeUrl ?? "",
        };
    }
    async updateLegalDocument(kind, content) {
        try {
            await setDoc(doc(this.db, "settings", kind), { content, lastUpdated: new Date().toISOString().slice(0, 10) }, { merge: true });
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
    async updateAppConfig(config) {
        try {
            await setDoc(doc(this.db, "settings", "app_config"), { ...config }, { merge: true });
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
    async updateAdBanner(banner) {
        try {
            await setDoc(doc(this.db, "settings", "ad_banner"), {
                enabled: banner.enabled,
                startDate: banner.startDate ? Timestamp.fromDate(banner.startDate) : null,
                endDate: banner.endDate ? Timestamp.fromDate(banner.endDate) : null,
                imageUrl: banner.imageUrl,
                pointToUrl: banner.pointToUrl,
            }, { merge: true });
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
}
//# sourceMappingURL=FirebaseSettingsRepository.js.map